export const MAX_PRODUCTS_PER_ROW = 2;
export const GUTTER_SPACE = 1;

export const CLASSNAMES = {
  CONTAINER: 'prod-ctr',
  PRODUCT: 'plp-prod',
  WISHLIST: 'wishlist-prod',
};

export const PRODUCT_HEIGHT = 326.65625;
export const PRODUCT_WIDTH = 186.5;
